/*
 * @Description: 导出、下载
 * @Author: 裴孚
 * @Date: 2022-10-09 11:15:20
 * @LastEditors: 裴孚
 * @LastEditTime: 2023-02-02 10:23:14
 * @FilePath: \ZHXY_VUE3.0\src\utils\requestDownload.js
 */
import axios from 'axios'
import qs from 'qs'
import { warningPrompt } from '@/utils/promptInfo'
import { ElLoading } from 'element-plus'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000
})

// request interceptor
service.interceptors.request.use(
  config => {
    if ($cookies.get('access_token')) {
      config.headers.Authorization = $cookies.get('access_token')
    }
    if (!(config.data instanceof FormData) && typeof config.data === 'object') {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

const exportExcel = async (url, params = {}) => {
  console.log(params)
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  // axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
  axios({
    method: 'post',
    url: process.env.VUE_APP_BASE_API + url,
    headers: { 'Content-Type': 'application/json', access_token: $cookies.get('access_token') },
    data: params,
    responseType: 'arraybuffer'
  }).then(res => {
    // 这里的type最好参考Response Headers里面的content-type，有可能是application/vnd.ms-excel
    const blob = new Blob([res.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    // 获取文件名，根据自己需要的分割
    if (res.headers['content-disposition']) {
      const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
      console.log(fileName)
      const a = document.createElement('a')
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = decodeURI(fileName)
      document.body.appendChild(a)
      a.style.display = 'none'
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    } else {
      warningPrompt('下载文件请求错误')
    }
    loading.close()
    // const headers = res.headers
    // const blob = new Blob([res.data], {
    //   type: headers['content-type']
    // })
    // console.log(blob, "blob")
    // const link = document.createElement('a')
    // link.href = window.URL.createObjectURL(blob)
    // const fileName = headers['content-disposition']
    // const title = fileName.includes('filename=') ? fileName.split('=')[1] : '下载的表单文件 '
    // link.download = decodeURI(title)
    // link.click()
  }, error => {
    loading.close()
    console.log(error)
  })
}

export default {
  service,
  exportExcel
}
